import { FormInstance } from "antd/lib/form";
import React from "react";
import Swal from "sweetalert2";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

interface IAyarlar_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IAyarlar_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  AktifSirket_N: any[];
  TedarikciListesiCount: any[];
  KullaniciListesi: any[];
  SifreUret_N: any[];
  KullaniciKayit: number;
  TriggerEvent: string;
  SetValueOf: any;
  Notify: boolean;
  SetFocusTo: any;
  Kullanici_Sil: number;
  TokenVer: string;
  ParametreAyarlari_N: number;
  IfThenElse: boolean;

  isMasterPageInitLoaded?: boolean;
  isMasterPageRecurringLoaded?: boolean;
}

export class Ayarlar_ScreenBase extends React.PureComponent<IAyarlar_ScreenProps, any> {
  ayarlar_622869_value_kuikaTableRef: React.RefObject<any>;
  ayarlar_557158_value_kuikaPaginationRef: React.RefObject<any>;
  ml = [
    {
      Id: "86c198d2-2610-49c1-b2d1-b0fad74723cd",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: []
    },
    {
      Id: "4f2b3965-e9ba-4eef-8e56-6e63d00b1621",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 323002, PropertyName: "tab", Value: "Kullanıcı Tanımlama" },
        { Id: 466003, PropertyName: "value", Value: "Kullanıcı Kodu" },
        { Id: 262088, PropertyName: "value", Value: "Ad Soyad" },
        { Id: 264904, PropertyName: "value", Value: "Parola" },
        { Id: 553038, PropertyName: "placeholder", Value: "***********" },
        { Id: 845256, PropertyName: "label", Value: "Şifre Oluştur" },
        { Id: 191287, PropertyName: "label", Value: "Kaydet" },
        { Id: 622869, PropertyName: "nodatafoundmessage", Value: "No data found." },
        { Id: 504910, PropertyName: "title", Value: "Kullanıcı Kodu" },
        { Id: 324272, PropertyName: "value", Value: "[datafield:cari_kodu]" },
        { Id: 876053, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 854549, PropertyName: "title", Value: "Kullanıcı Adı" },
        { Id: 489127, PropertyName: "value", Value: "[datafield:depo_kodu]" },
        { Id: 351834, PropertyName: "title", Value: "Şifre" },
        { Id: 25723, PropertyName: "value", Value: "[datafield:sifre]" },
        { Id: 204453, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 821325, PropertyName: "tab", Value: "Veri Tabanı Bağlantı Bilgileri" },
        { Id: 453226, PropertyName: "value", Value: "Dbname" },
        { Id: 601126, PropertyName: "value", Value: "Şube Kodu" },
        { Id: 698122, PropertyName: "value", Value: "Netsis User" },
        { Id: 310417, PropertyName: "value", Value: "Netsis Password" },
        { Id: 952832, PropertyName: "placeholder", Value: "***********" },
        { Id: 81910, PropertyName: "value", Value: "Nox User" },
        { Id: 256875, PropertyName: "value", Value: "Nox URL" },
        { Id: 206630, PropertyName: "label", Value: "Kaydet" }
      ]
    }
  ];
  defaultML = "en_US";
  screenHash = "";

  constructor(props) {
    super(props);
    this.ayarlar_622869_value_kuikaTableRef = React.createRef();
    this.ayarlar_557158_value_kuikaPaginationRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      AktifSirket_N: [],
      TedarikciListesiCount: [],
      KullaniciListesi: [],
      SifreUret_N: [],
      KullaniciKayit: 0,
      TriggerEvent: "",
      SetValueOf: "",
      Notify: false,
      SetFocusTo: "",
      Kullanici_Sil: 0,
      TokenVer: "",
      ParametreAyarlari_N: 0,
      IfThenElse: false,

      isMasterPageInitLoaded: false,
      isMasterPageRecurringLoaded: false
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("ayarlar", "fasontakiplayout_screen");
      return;
    }

    ReactSystemFunctions.validateToken();
    if (false) {
      await this.AyarlarPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("ayarlar", "fasontakiplayout_screen");
  }

  componentWillUnmount() {}

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("ayarlar", "fasontakiplayout_screen");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.AyarlarPageInit();
    }

    if (
      prevState.isMasterPageInitLoaded !== this.state.isMasterPageInitLoaded &&
      this.state.isMasterPageInitLoaded === true
    ) {
      await this.AyarlarPageInit();
    }
  };

  fillFormInitValues() {
    this.props.form.setFieldsValue({
      ayarlar_397591_value: this.state.KullaniciListesi?.at?.(0)?.cARI_KODU ?? undefined,
      ayarlar_961747_value: this.state.KullaniciListesi?.at?.(0)?.dEPO_KODU ?? undefined,
      ayarlar_161038_value: this.state.AktifSirket_N?.at?.(0)?.dbName ?? undefined,
      ayarlar_142568_value: this.state.AktifSirket_N?.at?.(0)?.subeKodu ?? undefined,
      ayarlar_579518_value: this.state.AktifSirket_N?.at?.(0)?.netsisUser ?? undefined,
      ayarlar_979676_value: this.state.AktifSirket_N?.at?.(0)?.noxUser ?? undefined,
      ayarlar_369893_value: this.state.AktifSirket_N?.at?.(0)?.noxUrl ?? undefined
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  setMasterPageInitLoaded = (value: boolean) => {
    this.setState({ isMasterPageInitLoaded: value });
  };

  setMasterPageRecurringLoaded = (value: boolean) => {
    this.setState({ isMasterPageRecurringLoaded: value });
  };

  AyarlarPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) return true;

    let localVar = {
      tip_1: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
      Kullanici_Tipi_2: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
      currentpage_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(this, "ayarlar_557158_value", "current", "", "", "")
        ),
        "number"
      ),
      pagesize_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(this, "ayarlar_557158_value", "pageSize", "", "", "")
        ),
        "number"
      )
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(this, "Ayarlar/AyarlarPageInit", localVar);
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.AktifSirket_N = result?.data.aktifSirket_N;
    formVars.ayarlar_161038_value = ReactSystemFunctions.toString(
      this,
      stateVars.AktifSirket_N?.length > 0 ? stateVars.AktifSirket_N[0]?.dbName : null
    );
    formVars.ayarlar_142568_value = ReactSystemFunctions.toString(
      this,
      stateVars.AktifSirket_N?.length > 0 ? stateVars.AktifSirket_N[0]?.subeKodu : null
    );
    formVars.ayarlar_579518_value = ReactSystemFunctions.toString(
      this,
      stateVars.AktifSirket_N?.length > 0 ? stateVars.AktifSirket_N[0]?.netsisUser : null
    );
    formVars.ayarlar_979676_value = ReactSystemFunctions.toString(
      this,
      stateVars.AktifSirket_N?.length > 0 ? stateVars.AktifSirket_N[0]?.noxUser : null
    );
    formVars.ayarlar_369893_value = ReactSystemFunctions.toString(
      this,
      stateVars.AktifSirket_N?.length > 0 ? stateVars.AktifSirket_N[0]?.noxUrl : null
    );
    stateVars.TedarikciListesiCount = result?.data.tedarikciListesiCount;
    stateVars.KullaniciListesi = result?.data.kullaniciListesi;

    this.props.form.setFieldsValue(formVars);
    this.setState(stateVars, () => {
      this.AyarlarPageInit1_();
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AyarlarPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) return true;

    stateVars.dataSource_622869 = this.state.KullaniciListesi;
    formVars.ayarlar_557158_total = ReactSystemFunctions.value(
      this,
      this.state.TedarikciListesiCount?.length > 0 ? this.state.TedarikciListesiCount[0]?.toplamKayitSayisi : null
    );

    formVars.ayarlar_161038_value = ReactSystemFunctions.toString(
      this,
      this.state.AktifSirket_N?.length > 0 ? this.state.AktifSirket_N[0]?.dbName : null
    );

    formVars.ayarlar_142568_value = ReactSystemFunctions.toString(
      this,
      this.state.AktifSirket_N?.length > 0 ? this.state.AktifSirket_N[0]?.subeKodu : null
    );

    formVars.ayarlar_579518_value = ReactSystemFunctions.toString(
      this,
      this.state.AktifSirket_N?.length > 0 ? this.state.AktifSirket_N[0]?.netsisUser : null
    );

    formVars.ayarlar_952832_value = ReactSystemFunctions.toString(
      this,
      this.state.AktifSirket_N?.length > 0 ? this.state.AktifSirket_N[0]?.netsisPass : null
    );

    formVars.ayarlar_979676_value = ReactSystemFunctions.toString(
      this,
      this.state.AktifSirket_N?.length > 0 ? this.state.AktifSirket_N[0]?.noxUser : null
    );

    formVars.ayarlar_369893_value = ReactSystemFunctions.toString(
      this,
      this.state.AktifSirket_N?.length > 0 ? this.state.AktifSirket_N[0]?.noxUrl : null
    );

    this.props.form.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  AyarlarComponent_845256_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) return true;
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {};

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(this, "Ayarlar/AyarlarComponent_845256_onClick", localVar);
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SifreUret_N = result?.data.sifreUret_N;
    this.props.form.setFieldsValue(formVars);
    this.setState(stateVars, () => {
      this.AyarlarComponent_845256_onClick1_();
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AyarlarComponent_845256_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) return true;

    formVars.ayarlar_553038_value = ReactSystemFunctions.toString(
      this,
      this.state.SifreUret_N?.length > 0 ? this.state.SifreUret_N[0]?.simplePassword : null
    );

    this.props.form.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AyarlarComponent_191287_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(this, "ayarlar_397591_value", "value", "", "", "")
        ),
        null
      ),
      message: "Kullanıcı Kodu Boş Bırakılamaz",
      formName: "ayarlar_397591_value",
      condition: true
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(this, "ayarlar_961747_value", "value", "", "", "")
        ),
        null
      ),
      message: "Ad Soyad Boş Bırakılamaz",
      formName: "ayarlar_961747_value",
      condition: true
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(this, "ayarlar_553038_value", "value", "", "", "")
        ),
        null
      ),
      message: "Parola Boş Bırakılamaz",
      formName: "ayarlar_553038_value",
      condition: true
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) return true;
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CARI_KODU_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, ReactSystemFunctions.value(this, "ayarlar_397591_value", "value", "", "", "")),
        "string"
      ),
      DEPO_KODU_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, ReactSystemFunctions.value(this, "ayarlar_961747_value", "value", "", "", "")),
        "string"
      ),
      SIFRE_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(this, "ayarlar_553038_value", "value", "", "", "")
        ),
        "string"
      ),
      TIP_0: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
      Kullanici_Kodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, ReactSystemFunctions.value(this, "ayarlar_397591_value", "value", "", "", "")),
        "string"
      ),
      CARI_ISIM_0: ReactSystemFunctions.convertToTypeByName(null, "string")
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(this, "Ayarlar/AyarlarComponent_191287_onClick", localVar);
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.KullaniciKayit = result?.data.kullaniciKayit;
    this.props.form.setFieldsValue(formVars);
    this.setState(stateVars, () => {
      this.AyarlarComponent_191287_onClick1_();
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AyarlarComponent_191287_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) return true;

    await this.AyarlarPageInit();

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(this, "ayarlar_397591_value", null, null);
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(this, "ayarlar_961747_value", null, null);
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(this, "ayarlar_553038_value", null, null);
    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "f9d0c738_31aa_2e71_5828_f708242c536c_notify",
        this.defaultML,
        "Kayıt Tamamlandı."
      ),
      "success",
      "bottom-right",
      3
    );

    this.props.form.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AyarlarComponent_602606_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) return true;
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      "ayarlar_397591_value",
      ReactSystemFunctions.value(this, "ayarlar_622869_value", ".cARI_KODU"),
      null
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      "ayarlar_961747_value",
      ReactSystemFunctions.value(this, "ayarlar_622869_value", ".dEPO_KODU"),
      null
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      "ayarlar_553038_value",
      ReactSystemFunctions.value(this, "ayarlar_622869_value", ".sIFRE"),
      null
    );

    this.props.form.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AyarlarComponent_737536_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) return true;
    KuikaAppManager.showSpinner(this);

    stateVars.SetFocusTo = await ReactSystemFunctions.setFocusTo("397591");

    this.props.form.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AyarlarComponent_532136_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) return true;
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CARI_KODU_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "ayarlar_622869_value", "cARI_KODU"),
        "string"
      ),
      TIP_0: ReactSystemFunctions.convertToTypeByName(true, "boolean")
    };

    KuikaAppManager.showSpinner(this);

    Swal.fire({
      title: ReactSystemFunctions.translateCustomActions(
        this.ml,
        "8e1e1076_993c_da84_dfd9_457f2911935f_confirmation",
        this.defaultML,
        "Seçilen Kullanıcı Silinsin mi?"
      ),
      icon: "warning",
      showCancelButton: true,
      confirmButtonText:
        localStorage.getItem("ml") === "tr_TR"
          ? "Onayla"
          : localStorage.getItem("ml") === "fr_FR"
          ? "Confirmer"
          : "Confirm",
      cancelButtonText:
        localStorage.getItem("ml") === "tr_TR"
          ? "Vazgeç"
          : localStorage.getItem("ml") === "fr_FR"
          ? "Annuler"
          : "Cancel"
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (true) {
          KuikaAppManager.showSpinner(this);
        }
        let result = await KuikaAppManager.ApiRequest(this, "Ayarlar/AyarlarComponent_532136_onClick", localVar);
        if (!KMainFunctions.IsResStatus2XX(result)) return true;

        stateVars.Kullanici_Sil = result?.data.kullanici_Sil;
        this.props.form.setFieldsValue(formVars);
        this.setState(stateVars, () => {
          this.AyarlarComponent_532136_onClick1_();
        });
      }
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AyarlarComponent_532136_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) return true;

    await this.AyarlarPageInit();

    this.props.form.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AyarlarComponent_557158_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) return true;
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Kullanici_Tipi_0: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
      currentpage_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(this, "ayarlar_557158_value", "current", "", "", "")
        ),
        "number"
      ),
      pagesize_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(this, "ayarlar_557158_value", "pageSize", "", "", "")
        ),
        "number"
      )
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(this, "Ayarlar/AyarlarComponent_557158_onChange", localVar);
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.KullaniciListesi = result?.data.kullaniciListesi;

    this.props.form.setFieldsValue(formVars);
    this.setState(stateVars, () => {
      this.AyarlarComponent_557158_onChange1_();
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AyarlarComponent_557158_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) return true;

    await this.AyarlarPageInit();

    stateVars.dataSource_622869 = this.state.KullaniciListesi;

    this.props.form.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AyarlarComponent_206630_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) return true;
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      url_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, ReactSystemFunctions.value(this, "ayarlar_369893_value", "value", "", "", "")),
        "string"
      ),
      SubeKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, ReactSystemFunctions.value(this, "ayarlar_142568_value", "value", "", "", "")),
        "string"
      ),
      NetsisPasword_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(this, "ayarlar_952832_value", "value", "", "", "")
        ),
        "string"
      ),
      NetsisUser_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, ReactSystemFunctions.value(this, "ayarlar_579518_value", "value", "", "", "")),
        "string"
      ),
      DBName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, ReactSystemFunctions.value(this, "ayarlar_161038_value", "value", "", "", "")),
        "string"
      ),
      DBUser_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, ReactSystemFunctions.value(this, "ayarlar_979676_value", "value", "", "", "")),
        "string"
      ),
      aktifToken_1: ReactSystemFunctions.convertToTypeByName(null, "string"),
      dbName_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, ReactSystemFunctions.value(this, "ayarlar_161038_value", "value", "", "", "")),
        "string"
      ),
      netsisPass_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, ReactSystemFunctions.value(this, "ayarlar_952832_value", "value", "", "", "")),
        "string"
      ),
      netsisUser_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, ReactSystemFunctions.value(this, "ayarlar_579518_value", "value", "", "", "")),
        "string"
      ),
      noxUrl_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, ReactSystemFunctions.value(this, "ayarlar_369893_value", "value", "", "", "")),
        "string"
      ),
      noxUser_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, ReactSystemFunctions.value(this, "ayarlar_979676_value", "value", "", "", "")),
        "string"
      ),
      subeKodu_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(this, "ayarlar_142568_value", "value", "", "", "")
        ),
        "number"
      )
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(this, "Ayarlar/AyarlarComponent_206630_onClick", localVar);
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.TokenVer = result?.data.tokenVer;
    stateVars.ParametreAyarlari_N = result?.data.parametreAyarlari_N;
    this.props.form.setFieldsValue(formVars);
    this.setState(stateVars, () => {
      this.AyarlarComponent_206630_onClick1_();
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AyarlarComponent_206630_onClick_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) return true;
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(this, null, "default", "bottom-right", 1);

    this.props.form.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  AyarlarComponent_206630_onClick_else1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) return true;
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "322223d9_3246_5224_5ade_c7c6952b6fd4_notify",
        this.defaultML,
        "Bağlantı Başarılı"
      ),
      "success",
      "bottom-right",
      3
    );

    this.props.form.setFieldsValue(formVars);
    this.setState(stateVars, () => {
      this.AyarlarComponent_206630_onClick_else11_();
    });

    return isErrorOccurred;
  };
  AyarlarComponent_206630_onClick_else11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) return true;
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      aktifToken_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.TokenVer),
        "string"
      ),
      dbName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(this, "ayarlar_161038_value", "value", "", "", "")
        ),
        "string"
      ),
      netsisPass_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(this, "ayarlar_952832_value", "value", "", "", "")
        ),
        "string"
      ),
      netsisUser_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(this, "ayarlar_579518_value", "value", "", "", "")
        ),
        "string"
      ),
      noxUrl_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(this, "ayarlar_369893_value", "value", "", "", "")
        ),
        "string"
      ),
      noxUser_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(this, "ayarlar_979676_value", "value", "", "", "")
        ),
        "string"
      ),
      subeKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, ReactSystemFunctions.value(this, "ayarlar_142568_value", "value", "", "", "")),
        "number"
      )
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(this, "Ayarlar/AyarlarComponent_206630_onClick_else11_", localVar);
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ParametreAyarlari_N = result?.data.parametreAyarlari_N;
    this.props.form.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  AyarlarComponent_206630_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) return true;
    if (ReactSystemFunctions.contains(ReactSystemFunctions.toString(this, this.state.TokenVer), "Bağlantı Başarısız")) {
      isErrorOccurred = await this.AyarlarComponent_206630_onClick_if1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred = await this.AyarlarComponent_206630_onClick_else1();
      if (isErrorOccurred) return true;
    }

    this.props.form.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AyarlarComponent_622869_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) return true;
    KuikaAppManager.showSpinner(this);

    ReactSystemFunctions.setValueOf(
      this,
      "ayarlar_961747_value",
      ReactSystemFunctions.value(this, "ayarlar_622869_dataSource", "dataSource"),
      "value"
    );

    ReactSystemFunctions.setValueOf(
      this,
      "ayarlar_397591_value",
      ReactSystemFunctions.value(this, "ayarlar_622869_dataSource", "dataSource"),
      "value"
    );

    this.props.form.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId) {
    let isErrorOccurred = false;
  }
}
